import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock, X } from "lucide-react";
import { Price } from "@/context/CurrencyContext";

export default function SearchSuggestionsList({
  query = "",
  suggestions = [],
  recent = [],
  onSelect,
  onSelectRecent,
  onRemoveRecent,
  testidPrefix = "search-suggestion",
}) {
  const navigate = useNavigate();
  const showRecent = !query.trim() && recent.length > 0;
  const showSuggestions = query.trim().length > 0 && suggestions.length > 0;
  if (!showRecent && !showSuggestions) return null;

  return (
    <div
      className="absolute top-full left-0 right-0 mt-2 bg-white border border-cream-200 rounded-sm shadow-xl overflow-hidden z-50 max-h-80 overflow-y-auto"
      data-testid={`${testidPrefix}-list`}
    >
      {showRecent && (
        <div className="p-3" data-testid={`${testidPrefix}-recent-chips`}>
          <div className="text-[11px] uppercase tracking-wider text-foreground/40 mb-2 flex items-center gap-1.5">
            <Clock className="w-3 h-3" /> Recent searches
          </div>
          <div className="flex flex-wrap gap-2">
            {recent.map((q) => (
              <button
                key={q}
                type="button"
                data-testid={`${testidPrefix}-recent-${q}`}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onSelectRecent?.(q)}
                className="group flex items-center gap-1.5 pl-3 pr-1.5 py-1.5 rounded-full bg-cream border border-cream-200 text-xs text-foreground/80 hover:border-saffron hover:text-saffron transition-colors"
              >
                {q}
                <span
                  data-testid={`${testidPrefix}-recent-remove-${q}`}
                  onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); onRemoveRecent?.(q); }}
                  className="opacity-40 group-hover:opacity-100 hover:text-deepred transition-opacity"
                >
                  <X className="w-3 h-3" />
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
      {showSuggestions && suggestions.map((t) => (
        <button
          key={t.slug}
          type="button"
          data-testid={`${testidPrefix}-${t.slug}`}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => {
            onSelect?.();
            navigate(`/tours/${t.slug}`);
          }}
          className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-cream text-left transition-colors border-b border-cream-100 last:border-0"
        >
          <img src={t.image_url} alt={t.title} className="w-12 h-10 object-cover rounded-sm flex-shrink-0" />
          <div className="min-w-0 flex-1">
            <div className="text-sm font-medium text-foreground truncate">{t.title}</div>
            <div className="text-xs text-foreground/55">{t.country} · {t.duration}</div>
          </div>
          <div className="text-xs font-medium text-deepred flex-shrink-0">
            <Price usd={t.price_usd} />
          </div>
        </button>
      ))}
    </div>
  );
}
